"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Picasso_1 = require("../Picasso");
Picasso_1.PicassoProvider.override(({ palette }) => ({
    MuiOutlinedInput: {
        root: {
            '& $notchedOutline': {
                borderColor: palette.grey[50],
                borderRadius: 0
            },
            '&$focused': {
                '& $notchedOutline': {
                    borderWidth: '1px'
                }
            },
            '&:hover': {
                '&:not($disabled)&:not($focused)&:not($error)': {
                    '& $notchedOutline': {
                        borderColor: palette.primary.main
                    }
                }
            }
        },
        input: {
            border: 'solid 1px transparent'
        },
        multiline: {
            padding: 0
        },
        error: {
            '$root& $notchedOutline': {
                borderColor: palette.error.light
            }
        },
        notchedOutline: {},
        adornedStart: {
            paddingRight: 0
        },
        adornedEnd: {
            paddingRight: 0
        }
    }
}));
exports.default = {
    input: {}
};
//# sourceMappingURL=styles.js.map